import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { VonPageResponseModel } from '@von-development-studio/angular-rest-service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BaseService } from 'src/app/core/base/base.service';
import { RestService } from 'src/app/core/service/rest.service';
import { CommonCieModel } from 'src/app/model/common/cie';
import { commonCieActions } from 'src/app/store/common/cie/cie.action';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CieService extends BaseService {
  constructor(protected store: Store<any>, protected rest: RestService) {
    super();
  }

  getCieLazyLoad = (): Observable<VonPageResponseModel<CommonCieModel>> =>
    this.store.select('common', 'cie', 'result');

  readCie = (
    page: number,
    size: number,
    query: string
  ): Observable<VonPageResponseModel<CommonCieModel>> =>
    this.rest
      .get<VonPageResponseModel<CommonCieModel>>({
        url: `${environment.endpoints.common}/cie/paged`,
        params: {
          page,
          size,
          query,
        },
      })
      .pipe(
        tap((result) =>
          this.store.dispatch(commonCieActions.setResultAction(result))
        )
      );

  downloadTemplate = () =>
    (window.location.href = `${environment.endpoints.commonStatic}/cie-template.xlsx`);
}
